import React from 'react';

import { Backdrop } from '@material-ui/core';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const CustomBackdrop = (props) => {
  const { filtersMenuOpened } = useSelector((state) => state.filtersMenu);
  const isAnyCustomMenuOpen = Boolean(
    Object.keys(filtersMenuOpened).reduce((previous, key) => previous + filtersMenuOpened[key], 0)
  );
  return <StyledBackdrop open={isAnyCustomMenuOpen} />;
};

export default CustomBackdrop;

const StyledBackdrop = styled(Backdrop)`
  z-index: 1;
`;
